module.exports = __webpack_public_path__ + "img/project10_0.jpg.e28a78cd.webp";